export default __webpack_public_path__ + "static/6814-f3abde15edf2f991181da8dd36e63fbc.jpg";